var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxCircleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM6.93166 9.05664L10.7887 5.19968C11.0549 4.93341 11.4866 4.93345 11.7529 5.19973C12.0192 5.466 12.0192 5.89768 11.7529 6.16395L7.41375 10.503C7.28589 10.6308 7.11248 10.7027 6.93166 10.7027H6.93161C6.7508 10.7027 6.57739 10.6308 6.44952 10.503L4.1997 8.25305C3.93343 7.98677 3.93343 7.55509 4.1997 7.28882C4.46598 7.02259 4.8977 7.02264 5.16393 7.28886L6.93166 9.05664Z",
    fill: "#003B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxCircleChecked);
export default __webpack_public_path__ + "static/media/CheckBox-Circle-Checked.90715452fbdcee4e2f8b30248610effe.svg";
export { ForwardRef as ReactComponent };